import { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    Typography,
    Box
} from '@mui/material';
import { Form, Col } from 'react-bootstrap';

export default function EquipmentActionPasswordConfirmation({
    open,
    onClose,
    action,
    equipmentName,
    equipmentCod,
    onConfirm,
    checkingPassword
}) {
    const [step, setStep] = useState(1);
    const [password, setPassword] = useState('');

    useEffect(() => {
        setPassword('');
        setStep(1);
    }, [open]);

    const handleInitialConfirm = () => {
        setStep(2);
    };

    const handleBack = () => {
        setStep(1);
        onClose();
    };

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        onConfirm(password);
    };

    return (
        <>
            <Dialog
                open={open && step === 1}
                onClose={onClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ textAlign: 'center', color: 'primary.main', fontWeight: 'bold' }}>
                    Confirmar modificação do atributo <b>{action?.toUpperCase()}</b> no {equipmentName} {equipmentCod && `(${equipmentCod})`}
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body1" paragraph>
                            <b>Atenção:</b> Esta é uma ação que requer cuidado e pode afetar diretamente o funcionamento da usina fotovoltaica.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Você está prestes a modificar o atributo <span className='text-primary'><b>{action?.toUpperCase()}</b></span> do equipamento <b>{equipmentName}</b>.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Col className="col-6 p-1">
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleBack}
                            fullWidth
                            size="medium"
                        >
                            Cancelar
                        </Button>
                    </Col>
                    <Col className="col-6 p-1">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleInitialConfirm}
                            fullWidth
                            size="medium"
                        >
                            Continuar
                        </Button>
                    </Col>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open && step === 2}
                onClose={handleBack}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ textAlign: 'center', color: 'primary.main', fontWeight: 'bold' }}>
                    CONFIRMAÇÃO DE SEGURANÇA
                </DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body1" paragraph sx={{ mb: 3 }}>
                        Para confirmar esta ação, <b>digite sua senha</b> no campo abaixo:
                    </Typography>

                    <Form onSubmit={handlePasswordSubmit}>
                        <Form.Group controlId="passwordConfirmation">
                            <Form.Control
                                type="password"
                                placeholder="Digite sua senha de acesso"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoFocus
                                required
                                size="lg"
                            />
                        </Form.Group>
                    </Form>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Col className="col-6 p-1">
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleBack}
                            fullWidth
                            size="medium"
                        >
                            Voltar
                        </Button>
                    </Col>
                    <Col className="col-6 p-1">
                        <Button
                            type="submit"
                            variant="contained"
                            color="success"
                            disabled={checkingPassword || !password}
                            onClick={handlePasswordSubmit}
                            fullWidth
                            size="medium"
                            startIcon={checkingPassword ? <CircularProgress size={20} /> : null}
                        >
                            {checkingPassword ? 'Verificando...' : 'Confirmar'}
                        </Button>
                    </Col>
                </DialogActions>
            </Dialog>
        </>
    );
};